export type ComponentMountable = {
  /**
 *
 *
 *
 *
 *
 */
  readonly mounted: boolean | undefined;

  /*                                */
  __$$: "Mountable Component Marker";
};

/**
 *
 *
 */
export interface HTMLMountableElement extends HTMLElement, ComponentMountable {}

/**
 *
 *
 */
export type WaitForMountElementInput =
  | HTMLMountableElement
  | {
      /**
 *
 *
 */
      [Symbol.iterator](): ArrayIterator<HTMLMountableElement>;
    }
  | null
  | undefined;

export type ExtractWaitForMountResult<E extends WaitForMountElementInput> =
  E extends HTMLMountableElement
    ? HTMLMountableElement
    : E extends (infer U)[]
      ? U[]
      : E extends NodeListOf<infer U>
        ? U[]
        : E extends HTMLCollectionOf<infer U>
          ? U[]
          : null | undefined;

export const setMountState = <E extends HTMLElement & ComponentMountable>(
  component: E,
  state: boolean,
): void => {
  /*                                                                                          */
  (component as { mounted?: boolean }).mounted = state;
};

export const waitFormMountElement = (
  element: HTMLMountableElement,
  options: AddEventListenerOptions,
): Promise<HTMLMountableElement> =>
  new Promise((resolve) => {
    if (element.mounted) return resolve(element);
    element.addEventListener("oc-mount", () => resolve(element), options);
  });

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const waitForMount = <E extends WaitForMountElementInput>(
  component: E,
  options?: AddEventListenerOptions,
): Promise<ExtractWaitForMountResult<E>> => {
  if (!component) return Promise.resolve(component) as never;

  const opts = { ...options, once: true };

  if (Symbol.iterator in component && typeof component[Symbol.iterator] === "function") {
    return Promise.all(
      [...(component as HTMLMountableElement[])].map((comp) => waitFormMountElement(comp, opts)),
    ) as never;
  }

  return waitFormMountElement(component as HTMLMountableElement, opts) as never;
};
